import {EXCLUDE_USER_IDS} from '../routing-const';

export function getIsUserAvailable(id: number): boolean {
    return !EXCLUDE_USER_IDS.includes(id);
}
